import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-best-dex',
  templateUrl: './best-dex.component.html',
  styleUrls: ['./best-dex.component.scss']
})
export class BestDexComponent {
  // group=[{
  //   name: "ETH",
  //   value: "eth",
  //   flag: "eth"
  // }]
  // selectedLanguage:any;
  // change(selectedValue: string) {
  //   this.selectedLanguage = this.group.find(lang => lang.value === selectedValue);
  // }

}
